
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".es-popup-button");
  if (!buttons.length) return;

  // Start pulse on all buttons
  setTimeout(() => {
    buttons.forEach((btn) => {
      btn.classList.add("attention");
    });
  }, 2000);

  // Shake all buttons every 6 seconds
  setInterval(() => {
    buttons.forEach((btn) => {
      btn.classList.remove("attention");
      btn.classList.add("shake");

      setTimeout(() => {
        btn.classList.remove("shake");
        btn.classList.add("attention");
      }, 450);
    });
  }, 6000);

  // Stop attention when user interacts
  buttons.forEach((btn) => {
    btn.addEventListener("click", () => {
      btn.classList.remove("attention", "shake");
    });

    btn.addEventListener("mouseenter", () => {
      btn.classList.remove("attention");
    });

    btn.addEventListener("mouseleave", () => {
      btn.classList.add("attention");
    });
  });
});
